import type { CallHistoryItem } from '../../types';
import { isCallTerminalForControlPanel } from './liveControlVisibility';

/**
 * Merge one incremental drawer update without allowing terminal state to regress.
 *
 * Why this exists:
 * - the detail drawer receives lightweight websocket events first and then
 *   follows up with a canonical detail fetch;
 * - in the post-transfer human phase, the fetch can briefly return an older
 *   non-terminal payload after the terminal websocket event already arrived;
 * - once the drawer has observed a terminal state, it must not visually reopen
 *   the live control surface because of a regressive follow-up payload.
 */
export function mergeCallDetailState(
  current: CallHistoryItem | null,
  incoming: Partial<CallHistoryItem> | null | undefined,
): CallHistoryItem | null {
  if (!incoming) {
    return current;
  }
  if (!current) {
    return incoming as CallHistoryItem;
  }

  const merged: CallHistoryItem = {
    ...current,
    ...incoming,
  };

  if (isCallTerminalForControlPanel(current) && !isCallTerminalForControlPanel(merged)) {
    return {
      ...merged,
      status: current.status,
      endedAt: current.endedAt,
    };
  }

  return merged;
}
